import React from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  quizButton: {
    width: 'auto',
    '@media(max-width: 1050px)': {
      marginRight: '0',
      marginBottom: '16px',
    }
  },
  skipButton: {
    width: 'auto',
    marginRight: 10,
    '@media(max-width: 1050px)': {
      marginRight: '0',
    }
  },
  showAnswers: {
    width: 'auto',
    marginRight: 10,
    '@media(max-width: 1050px)': {
      marginRight: '0',
    }
  }
}))

const ButtonsBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 1050px) {
    flex-direction: column;
    justify-content: space-between;
    & > a,
    button {
      width: 100%;
      margin-bottom: 12px
    }
  }
`

const NavigationButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 25rem;
  @media screen and (max-width: 1050px) {
    flex-direction: column;
    justify-content: center;
    width: 100%;
    & > a,
    button {
      width: 100%;
    }
  }
`

const NavigationButtonsEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 25rem;
  @media screen and (max-width: 1050px) {
    flex-direction: column;
    justify-content: center;
    width: 100%;
    & > a,
    button {
      width: 100%;
    }
  }
`

const QuizSubmitAnswerOrSkip = ({
  questionNumber,
  questionsNavigation,
  courseId,
  nextContent,
  isLastQuestion,
  isFirstQuestion,
  value,
  handleSelectedAnswer,
  showAnswers,
  isAnswersOn,
  handleFinishQuiz
}) => {
  const classes = useStyles()

  const handleSkip = (input, value) => {
    value ? questionsNavigation('next')
      :
      questionsNavigation('jump')
  }

  const finishQuiz = () => {
    questionsNavigation('finish')
    handleFinishQuiz()
  }

  return (
    questionNumber < 0 ? (
      <ButtonsBox>
        <Button variant="contained" color="primary" onClick={() => questionsNavigation('next')} className={classes.quizButton}>
          iniciar quiz
        </Button>
        <Button
          component={RouterLink}
          to={`/curso/${courseId}/${nextContent}`}
          color="primary"
          variant="outlined"
          endIcon={<ArrowForwardIosIcon style={{ fontSize: '14px' }} />}
        >Pular Quiz</Button>
      </ButtonsBox>
    ) : (
      <ButtonsBox className="isQuestion">
        <NavigationButtons>
          <Button
            disabled={isFirstQuestion}
            className={classes.skipButton}
            onClick={() => questionsNavigation('back')}
            color="primary"
            variant="outlined"
            startIcon={<ArrowBackIosIcon style={{ fontSize: '14px' }} />}
          >Questão anterior</Button>
          {isLastQuestion ? (
            <Button
            className={classes.skipButton}
            variant={!!value && !!value[questionNumber] ? 'contained' : 'outlined'}
            color="primary"
            onClick={() => finishQuiz()}
            endIcon={<ArrowForwardIosIcon style={{ fontSize: '16px' }} />}
          >
            Finalizar quiz
          </Button>
          ) : (
            <Button
            className={classes.skipButton}
            variant={!!value && !!value[questionNumber] ? 'contained' : 'outlined'}
            color="primary"
            onClick={() => handleSkip(isLastQuestion)}
            endIcon={<ArrowForwardIosIcon style={{ fontSize: '16px' }} />}
          >
            {!!value && !!value[questionNumber] ? 'Próxima questão' : 'Pular questão'}
          </Button>
          )}
        </NavigationButtons>
        <NavigationButtonsEnd>
          <Button
            disabled={!!value && !!value[questionNumber] ? false : true}
            className={classes.showAnswers}
            variant={!!value && !!value[questionNumber] ? 'contained' : 'outlined'}
            color="primary"
            onClick={() => showAnswers()}
          >
            {isAnswersOn ? 'Esconder Gabarito' : 'Ver gabarito'}
          </Button>
          <Button disabled={value && value[questionNumber]} variant="contained" color="primary" onClick={() => handleSelectedAnswer(value)} className={classes.quizButton}>
            Responder
          </Button>
        </NavigationButtonsEnd>
      </ButtonsBox>
    )
  )
}

export default QuizSubmitAnswerOrSkip
